/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Ausgebucht`
};

const en_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Fully booked`
};

const es_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Completo`
};

const fr_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Complet`
};

const it_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Completo`
};

const nl_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Volgeboekt`
};

const pt_poi_card__non_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Completo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__non_availability(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__non_availability", locale)
	if (locale === "de") return de_poi_card__non_availability(inputs)
	if (locale === "en") return en_poi_card__non_availability(inputs)
	if (locale === "es") return es_poi_card__non_availability(inputs)
	if (locale === "fr") return fr_poi_card__non_availability(inputs)
	if (locale === "it") return it_poi_card__non_availability(inputs)
	if (locale === "nl") return nl_poi_card__non_availability(inputs)
	return pt_poi_card__non_availability(inputs)
};